const transformText = (text) => {
    let newAnswers=['']
    let countArray=0
    for(let i = 0; i<text.length;i++){
        if(text[i]==='['&& text[i+1]==='?'){
            countArray+=1
            newAnswers[countArray]=''
            i+=2;
        }
        if(text[i]==='?'&& text[i+1]===']'){
            countArray+=1
            newAnswers[countArray]=''
            i+=2;
        }
        newAnswers[countArray]+=text[i]
    }
    if(newAnswers[newAnswers.length - 1] === '' || newAnswers[newAnswers.length - 1]==='undefined')
        newAnswers.pop();
    // setAnswers(text)
    return newAnswers
    // editAnswers(name,newAnswers)
}

export {transformText}